<template>
  <div class="home">
		<h1>Historial</h1>
    <lockscreen v-if="loading">
      <div>Espere un momento ...</div>
    </lockscreen>
    <b-table striped hover :items="items" :fields="fields" v-on:row-clicked="showTravel"></b-table>
    <b-modal id="bv-modal" title="Viaje" @hidden="cancel" hide-footer>
      <div v-if="currentObj && currentObj.status === 'Cancelado'">
        Boleto cancelado sin operaciones disponibles
      </div>
      <div v-else>
      	<div v-if="action === ''">
          <br>
          <br>
          <b-button block size="lg" variant="outline-primary" @click="setAction('ticket')">
            Asignar Boleto Físico
          </b-button>
          <br>
          <br>
        	<b-button block size="lg" variant="danger" @click="cancelTicket()">
            Cancelar Boleto
          </b-button>
        </div>
      	<div v-if="action === 'ticket'">
  	      <p class="my-4">Ingrese folio de boleto</p>
  	      <b-form-input v-model="ticketId" type="number" placeholder="Ingrese folio de boleto"></b-form-input>
  	      <br/>
  	      <b-button block size="lg" variant="outline-primary" @click="assignTicket()">
  	        Asignar Folio
  	      </b-button>
          <b-button block size="lg" variant="danger" @click="cancel()">
            Cancelar
          </b-button>
        </div>
        <div v-if="action === 'cancel'">
  	      <p class="my-4">¿Desea cancelar este viaje de retorno? Se dará de baja el registro para ir a recolectar al cliente.</p>

  	      <b-button block size="lg" variant="outline-primary" @click="cancelTicket()">
  	        Si
  	      </b-button>
          <b-button block size="lg" variant="danger" @click="cancel()">
            No
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue'
import Parse from 'parse'
import lockscreen from 'vue-lockscreen'

Vue.component('lockscreen', lockscreen)
var moment = require('moment-timezone')
var timezone = 'Etc/GMT-6'

export default {
  name: 'history',
  data() {
    return {
      loading: false,
    	fields: [
        {
          key: 'createdAt',
          label: 'Fecha de Venta',
          sortable: true,
          // Variant applies to the whole column, including the header and footer
          // variant: 'danger'
        },
        {
          key: 'name',
          label: 'Nombre',
          sortable: true
        },
        {
          key: 'phone',
          label: 'Teléfono',
          sortable: true
        },
        {
          key: 'origin',
          label: 'Origen',
          sortable: false
        },
        {
          key: 'destination',
          label: 'Destino',
        },
        {
          key: 'scheduledAt',
          label: 'Fecha de Reserva',
          sortable: true,
          // Variant applies to the whole column, including the header and footer
          // variant: 'danger'
        },
        {
          key: 'folio',
          label: 'Folio',
        },
        {
          key: 'status',
          label: 'Estatus',
        },
      ],
			items: [
      ],
      action: '',
      ticketId: null,
      currentObj: null,
      currentUser: null,
      currentSession: null
    }
  },
  async created() {
   
  },
  async mounted() {
    this.loading = true
    this.currentUser = Parse.User.current()
    this.currentSession = await Parse.Session.current()
    console.log('currentUser',this.currentUser, this.currentUser._getId(), this.currentSession)
   	this.load()
    this.loading = false
  },
  methods: {
  	load: async function () {
  		let vue = this
      let currentUser = Parse.User.current()
      const queues = await Parse.Cloud.run('getCurrentQueueSession', {
        userId: currentUser.id,
        sessionId: this.currentSession.id
      })
      /*
      let query = new Parse.Query('Queue')
      query.equalTo('status', 0)
      query.exists('scheludedAt')
      query.descending('createdAt')
      queues = await query.find()
      */
			vue.items = []
			let data = queues.map(function (queue) {
	      console.log('virtual', { name: queue.get('clientFirstName') + ' ' + queue.get('clientLastName'), origin: queue.get('originName'), destination: queue.get('destinyName'), createdAt: queue.get('createdAt'), folio: queue.get('folio') })
	      vue.items.push({
	      	queue: queue,
	      	name: queue.get('clientFirstName') + ' ' + queue.get('clientLastName'),
	      	phone: queue.get('clientPhone'),
	      	origin: queue.get('originName'),
	      	destination: queue.get('destinyName'),
	      	folio: queue.get('folio'),
	      	status: queue.get('status') === 0 ? 'Abierto' : queue.get('status') === 2 ? 'Cancelado' : 'Asignado',
	      	createdAt: moment.tz(queue.get('createdAt'), 'America/Mexico_City').format('YYYY-MM-DD HH:mm:ss'),
	      	scheduledAt: moment.tz(queue.get('scheludedAt'), 'America/Mexico_City').format('YYYY-MM-DD HH:mm:ss')
	      })
	    })
			console.log('queues', queues)
  	},
  	showTravel: function (obj) {
  		console.log('obj', obj)
  		this.currentObj = obj
      this.$bvModal.show('bv-modal')
      this.ticketId = ''
    },
  	setAction: function (action) {
  		this.action = action
  	},
  	assignTicket: async function () {
      console.log('assingTicket', this.ticketId)
      if (this.ticketId.length !== 15) {
        alert('Se necesitan ingresar los 15 dígitos del código del boleto')
      } else {
        try {
          this.loading = false
          const result = await Parse.Cloud.run('setFolioAndCreateTravel2', {
            queueId: this.currentObj.queue.id,
            folio: this.ticketId
          })
          console.log('Result', result)
          if (!result.id) {
            this.loading = false
            alert(result)
            return
          }
          this.$bvModal.hide('bv-modal')
          this.cancel()
          this.load()
          this.loading = false
          alert('Boleto Asignado Correctamente')
          return
        } catch (error) {
          console.log('error', error)
          alert('Error al asignar folio ' + error.toString())
          this.loading = false
        }
      }
  	},
  	cancelTicket: async function () {
      let vue = this
      console.log('currentObj',vue.currentObj)
      
      //INICIO SI CONFIRMA
      const confirm = true
      vue.loading = true
      if (confirm) { 
        const result = await Parse.Cloud.run('cancelQueueScheduled', {
          queueId: vue.currentObj.queue.id
        })
        if (!result.id) {
          alert(result)
          vue.loading = false
          return
        }
        alert('Reservación Cancelada')
      } else {
        // alert('no cancelado')
      }
      this.$bvModal.hide('bv-modal')
      this.cancel()
      this.load()
      vue.loading = false


      //FINALIZA SI CONFIRMA

      console.log('termina submit')
      /*  
      console.log('assingTicket', this.currentObj.queue)
      const result = await Parse.Cloud.run('cancelQueueScheduled', {
        queueId: this.currentObj.queue.id
      })
      if (!result.id) {
        alert(result)
        return
      }
      this.$bvModal.hide('bv-modal')
      this.cancel()
      this.load()
      alert('Boleto Cancelado')
      */
  	},
  	cancel: function () {
  		console.log('cancel')
  		this.action = ''
      this.$bvModal.hide('bv-modal')
  	}
  }
}
</script>
